<template>
  <div
    class="loading-spinner"
    role="status"
  >
    <span class="sr-only">Loading</span>
    <span
      class="loading-ring"
      aria-hidden="true"
    />
  </div>
</template>

<script>
export default {
  name: 'LoadingStatus'
}
</script>

<style lang="scss" scoped>
// A full ring, not the library loader. That loader draws only a short dash,
// which reads as a dot once the step title is hidden.
.loading-spinner {
  align-items: center;
  display: flex;
  justify-content: center;
  min-height: 116px;
}

.loading-ring {
  animation: loading-spin .8s linear infinite;
  border: 3px solid $border-color;
  border-radius: 50%;
  border-top-color: $text-muted;
  height: 36px;
  width: 36px;
}

@media (prefers-reduced-motion: reduce) {
  .loading-ring {
    animation: none;
  }
}

@keyframes loading-spin {
  to {
    transform: rotate(360deg);
  }
}

.sr-only {
  border: 0;
  clip: rect(0, 0, 0, 0);
  height: 1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  white-space: nowrap;
  width: 1px;
}
</style>
